import { AVANTIO_INTEGRATION_ERROR } from "./error-codes.constants";
import ApiError from "../../errors/ApiError";

export class AvantioIntegrationError extends ApiError {
  constructor(message?: string) {
    super(AVANTIO_INTEGRATION_ERROR);
    if (message) {
      this.message = message;
    }
  }
}
